import { type Route } from '@angular/router';
import { NotFoundPage } from './pages/not-found/not-found.page';
import { ERROR_PATHS } from '../../core/constants/paths.constants';


export const ERRORS_ROUTES: Route[] = [
    {
        path: ERROR_PATHS.notFound,
        component: NotFoundPage,
    },
];